import { Tabs } from 'antd'
import styled from 'styled-components'

export const RightSection = styled.div`
  min-width: 360px;
  width: 30%;
  min-height: 851px;
  background: var(--color-bg);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-left: 20px;
  padding-right: 20px;
  overflow: hidden;
`

export const TrafficButton = styled.div<{ $active?: boolean }>`
  width: 81px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-bg);
  border-radius: 6px;
  padding: 10px 15px;
  box-shadow: var(--shadow-box);
  position: relative;
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    bottom: 0.5px;
    left: 50%;
    transform: translateX(-50%);
    width: 60%;
    height: 2px;
    background: ${(props) => (props.$active ? 'var(--color-primary)' : 'transparent')};
    border-radius: 4px;
    transition: background 0.3s ease;
  }
`

export const StyledTabs = styled(Tabs)`
  align-self: stretch;
  height: 849px;

  .ant-tabs-nav {
    width: 300px;
    margin: 19px 0 20px 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    height: 40px;
    overflow: visible !important;
  }

  .ant-tabs-nav::before {
    border: none !important;
  }

  .ant-tabs-nav-wrap {
    flex: 0 0 auto;
    background: var(--color-bg);
    border-radius: 6px;
    padding: 10px 17px;
    box-shadow: var(--shadow-box);
    overflow: visible !important;
  }

  .ant-tabs-nav-list {
    display: flex;
    overflow: visible !important;
  }

  .ant-tabs-tab {
    padding: 0;
    margin: 0;
    position: relative;
    overflow: visible !important;
  }

  .ant-tabs-tab + .ant-tabs-tab {
    margin-left: 34px;
  }

  .ant-tabs-tab-btn {
    color: var(--color-text-primary);
    font-size: 16px;
    font-weight: bold;
    position: relative;
    display: inline-block;
  }

  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: var(--color-primary);
  }

  .ant-tabs-ink-bar {
    display: none !important;
  }

  .ant-tabs-tab-active .ant-tabs-tab-btn::after {
    content: '';
    position: absolute;
    bottom: -7px;
    left: 0;
    right: 0;
    height: 2px;
    background: var(--color-primary);
    border-radius: 4px;
    width: 100%;
    z-index: 10;
  }

  .ant-tabs-content-holder {
    padding-top: 0;
  }

  .ant-tabs-nav-operations {
    display: none !important;
  }

  .ant-tabs-tab[data-node-key='traffic'] {
    display: none !important;
  }

  .ant-tabs-extra-content {
    display: flex !important;
    align-items: center;
    margin-left: auto;
  }
`

export const Text = styled.span<{
  $bold?: boolean
  $size?: number
  $color?: string
  $marginRight?: number
  $marginBottom?: number
  $marginTop?: number
}>`
  color: ${(props) => props.$color || 'var(--color-text-primary)'};
  font-size: ${(props) => props.$size || 16}px;
  font-weight: ${(props) => (props.$bold ? '700' : 'normal')};
  margin-right: ${(props) => (props.$marginRight ? `${props.$marginRight}px` : '0')};
  margin-bottom: ${(props) => (props.$marginBottom ? `${props.$marginBottom}px` : '0')};
  margin-top: ${(props) => (props.$marginTop ? `${props.$marginTop}px` : '0')};
`
